<template>
    <div>
        <div class="px-3 py-2">
            <div class="d-flex"> 
                <div  class="btn-home-2 mb-4 mt-3 ms-auto">
                    <button type="button" class="btn btn-outline-main" @click="returnHome">
                        <i class="fas fa-home-lg-alt"></i> Inicio
                    </button>
                </div>
            </div>
            <div id="div-modal-cxc" class="d-flex justify-content-center">
                <div id="div-cxc" class="card w-100">
                    <div class="card-header text-white h4 text-center bg-main">
                        <strong>COMPRAS</strong>
                    </div>
                    <div class="card-body w-100 mt-2 mb-2 px-4">
                        <div class="row d-flex">
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <div class="card">
                                    <div class="card-header d-flex justify-content-between" style="background: #e1dedeb0">
                                        <span><i class="fas fa-store"></i>&nbsp; <strong>COMPRA</strong></span>
                                    </div>
                                    <div class="card-body mb-2">
                                        <div class="row d-flex">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                                                <label for="providerSelect">Proveedores</label>
                                                <v-select
                                                    class="text-dark flex-grow-1 mt-1"
                                                    label="name"
                                                    :options="proveOptions"
                                                    placeholder="Seleccione Proveedor"
                                                    @search="mtdGetProve"
                                                    v-model="cabezera.selectedProve"
                                                    :reduce="(name) => name.id"
                                                    required
                                                    :clearable="false"
                                                >
                                                    <template slot="no-options">
                                                    No hay Proveedores para la busqueda
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>
                                        <div class="row d-flex">
                                            <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                                                <label for="fechaCompra">F. de Compra</label>
                                                <input type="date" class="form-control mt-1" id="fechaCompra"   v-model="cabezera.date">
                                            </div>
                                            <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                                                <label for="numeroDocumento">Serie</label>
                                                <input type="text" class="form-control mt-1" id="numeroDocumento" placeholder="Digite Serie"   v-model="cabezera.serie">
                                            </div>
                                            <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                                                <label for="medioPago">Medio de Pago</label>
                                                <v-select
                                                    id="serviceSelect"
                                                    class="text-dark flex-grow-1 mt-1"
                                                    label="name"
                                                    :options="metoOptions"
                                                    placeholder="- Buscar Estado -"
                                                    v-model="cabezera.selectedMeto"
                                                    :reduce="option => option.id"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                <div class="card">
                                    <div class="card-header" style="background: #e1dedeb0">
                                        <span><i class="fas fa-coins"></i> <strong>PRODUCTOS</strong></span>
                                    </div>
                                    <div class="card-body">
                                        <div class="row d-flex">
                                            <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 mt-2">
                                                <label for="productoSelect">Producto</label>
                                                <v-select
                                                    class="text-dark flex-grow-1 mt-1"
                                                    label="name"
                                                    :options="prodOptions"
                                                    placeholder="Seleccione Producto"
                                                    @search="mtdGetProd"
                                                    v-model="purchase.selectedProd"
                                                    :reduce="(name) => name.id"
                                                    required
                                                    :clearable="false"
                                                >
                                                    <template slot="no-options">
                                                    No hay Productos para la busqueda
                                                    </template>
                                                </v-select>
                                            </div>
                                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mt-2">
                                                <label for="precio">Precio</label>
                                                <input type="text" class="form-control mt-1" id="precio" placeholder="Digite precio" 
                                                v-on:keypress="isNumber($event)" v-model="purchase.price">
                                            </div>
                                        </div>
                                        <div class="row d-flex">
                                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mt-2">
                                                <label for="cantidad">Cantidad</label>
                                                <input type="number" class="form-control mt-1" id="cantidad" placeholder="Cantidad"  
                                                @input="validateQuantity" v-model="purchase.quantity" min="1">
                                            </div>
                                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mt-2">
                                                <label for="subTotal">Sub-Total</label>
                                                <input type="text" class="form-control mt-1" id="subTotal" placeholder="Subtotal" v-model="purchase.subtotal" readonly>
                                            </div>
                                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 d-flex align-items-end mt-3">
                                                <button 
                                                    type="button" 
                                                    class="btn text-white"   
                                                    :disabled="!purchase.quantity || !purchase.price || !purchase.subtotal" 
                                                    style="background: #57cc99"
                                                    @click="mtdAddProd()">
                                                    <i class="fas fa-plus"></i> Agregar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-header d-flex justify-content-start mt-2" style="background: #e1dedeb0">
                                        <span><i class="fa fa-user"></i> <strong>LISTA DE PRODUCTOS</strong></span>
                                    </div>
                                    <div class="card-body">
                                        <div class="row d-flex">
                                            <div class="col-md-12 mt-2" id="content-timelinetable">
                                                <table id="tb-cxc" class="table table-bordered border-main" style="font-size: 13px">
                                                    <caption class="py-0 my-0"></caption>
                                                    <thead>
                                                        <tr class="text-center text-white border-white bg-main align-middle">
                                                            <th scope="col" class="table-th-number">N°</th>
                                                            <th scope="col">PRODUCTO</th>
                                                            <th scope="col" class="table-th-acciones">PRECIO</th>
                                                            <th scope="col" class="table-th-acciones">CANTIDAD</th>
                                                            <th scope="col" class="table-th-acciones">SUBTOTAL</th>
                                                            <th scope="col" class="table-th-acciones">ACCIONES</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in  cabezera.dataPurchase" :key="item.id" class="text-center align-middle">
                                                            <td>{{ index + 1 }}</td>
                                                            <td>{{ item.nameProd }}</td>
                                                            <td>{{ item.price }}</td>
                                                            <td>{{ item.quantity }}</td>
                                                            <td>{{ item.subtotal }}</td>
                                                            <td><button type="button" @click="mtdDeleteProd(item.id)" class="btn btn-danger btn-sm px-1 py-0" ><i class="fas fa-trash-alt text-white"></i></button></td>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="4" scope="col" class="text-center">TOTAL</th>
                                                            <th colspan="2" scope="col" class="text-center">{{ total }}</th>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 d-flex justify-content-end">
                                                <button type="button" class="btn btn-info text-white" :disabled="isDisabled"  @click="registerCompra()">
                                                    <i class="fas fa-save"></i> Guardar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </div>
</template>
<script>
import { mapActions } from "vuex";
import moment from "moment";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";

export default {
  name: "c-pages-compras",
  components: {
    SweetAlert,
  },
  data() {
    return {
      swal: null,
      search: "",
      data: [],
      dataShow: [],
      proveOptions: [],
      metoOptions: [],
      prodOptions: [],
      modal: {
        title: "",
        modal_form: false,
        payload: [],
        idReci: null,
      },
      purchase: {
        id: null,
        price: null,
        quantity: null,
        subtotal: null,
        selectedProd: "",
        nameProd: "",
      },
      cabezera: {
        campu_id: "",
        selectedProve: "",
        selectedMeto: "",
        date: "",
        serie: "",
        dataPurchase: [],
        total: null
      },
      //Pag
      page: 0,
      selectPage: 1,
      stepPagination: [],
      totalPagesToShow: 4,
    };
  },
  created() {
    this.mtdGetMeto();
  },
  watch: {
    selectPage() {
      this.calculateData(10);
    },
    'purchase.price': function() {
      this.calculateSubtotal();
    },
    'purchase.quantity': function() {
      this.calculateSubtotal();
    },
  },
  computed: {
    cpData() {
      return this.dataShow;
    },

    limitedStepPagination() {
      const totalPages = this.stepPagination.length;
      const currentPage = this.selectPage;

      let startPage = 1;
      let endPage = totalPages;
      if (totalPages > this.totalPagesToShow) {
        const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

        if (currentPage > halfPagesToShow) {
          startPage = currentPage - halfPagesToShow;
          endPage = currentPage + halfPagesToShow - 1;

          if (endPage > totalPages) {
            endPage = totalPages;
            startPage = totalPages - this.totalPagesToShow + 1;
          }
        } else {
          endPage = this.totalPagesToShow;
        }
      }

      return Array.from(
        {
          length: endPage - startPage + 1,
        },
        (_, i) => startPage + i
      );
    },
    isDisabled() {
      return !this.cabezera.selectedProve || 
             !this.cabezera.selectedMeto || 
             !this.cabezera.date || 
             !this.cabezera.serie || 
             this.cabezera.dataPurchase.length === 0;
    },

    total() {
      const total = this.cabezera.dataPurchase.reduce((sum, item) => {
        return sum + parseFloat(item.subtotal || 0);
      }, 0);
      return total.toFixed(2);  
    }
  },
  methods: {
    ...mapActions(["get", "post"]),

    returnHome: function () {
      this.$emit("returnHome");
    },

    calculateSubtotal() {
      if (this.purchase.price !== null && this.purchase.quantity !== null) {
        this.purchase.subtotal = (this.purchase.price * this.purchase.quantity).toFixed(2);
      } else {
        this.purchase.subtotal = null; 
      }
    },

    mtdGetProve: function (search, loading) {
        if (search.length > 2) {
            this.proveOptions = [];
            this.cabezera.selectedProve =  "",
            loading(true);
            this.get({
                url: this.$store.getters.get__url + "/Logis/purchase/mtdGetProve",
                token: this.$store.getters.get__token,
            })
            .then((response) => {
                this.proveOptions = response.data;
                loading(false);
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        }
    },

    mtdGetMeto: function () {
        this.get({
            url: this.$store.getters.get__url + "/Logis/purchase/mtdGetMeto",
            token: this.$store.getters.get__token,
        })
        .then((response) => {
            this.metoOptions = response.data;
        })
        .catch((errors) => {
            this.$refs.SweetAlert.showError(errors);
        });
    },

    mtdGetProd: function (search, loading) {
        if (search.length > 2) {
            this.prodOptions = [];
            this.purchase.selectedProd =  "",
            loading(true);
            this.get({
                url: this.$store.getters.get__url + "/Logis/purchase/mtdGetProd",
                token: this.$store.getters.get__token,
            })
            .then((response) => {
                this.prodOptions = response.data;
                loading(false);
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        }
    },

    mtdAddProd: function(){
        const selectedProduct = this.prodOptions.find(product => product.id === this.purchase.selectedProd);
        if (selectedProduct) {
            this.purchase.nameProd = selectedProduct.name;
        } else {
            this.purchase.nameProd = ""; 
        }
        this.purchase.id =  this.cabezera.dataPurchase.length + 1;
        this.cabezera.total = (parseFloat(this.cabezera.total) || 0) + (parseFloat(this.purchase.subtotal) || 0);
        this.cabezera.dataPurchase.push(this.purchase);
        this.purchase = {
            id: null,
            price: null,
            quantity: null,
            subtotal: null,
            selectedProd: "",
            nameProd: "",
        }
    },

    mtdDeleteProd: function(id) {
        this.$refs.SweetAlert.showConfirmSimple2("", "¿Estás seguro eliminar este Producto?", "warning", "Eliminar")
        .then((result) => {
            if (result.value) {
                const indice = this.cabezera.dataPurchase.findIndex(item => item.id === id);
                if (indice !== -1) {
                    this.cabezera.dataPurchase.splice(indice, 1);
                    this.purchase = {
                        id: null,
                        price: null,
                        quantity: null,
                        subtotal: null,
                        selectedProd: "",
                        nameProd: "",
                    }
                }
            }
        });
    },

    registerCompra: function() {
        this.$refs.SweetAlert.showConfirmSimple2("", "¿Estás seguro de registrar esta Compra?", "warning", "Registrar")
        .then((result) => {
            if (result.value) {
                this.cabezera.campu_id = this.$store.getters.get__campus;
                this.post({
                    url: this.$store.getters.get__url + "/Logis/purchase/registerPurchase",
                    token: this.$store.getters.get__token,
                    params: this.cabezera,
                })
                .then((response) => {
                    if(response.statusCode == 200){
                        this.$refs.SweetAlert.showSuccess("Compra Registrada Correctamente");
                        this.cabezera =  {
                            campu_id: "",
                            selectedProve: "",
                            selectedMeto: "",
                            date: "",
                            serie: "",
                            dataPurchase: [],
                            total: null
                        },
                        this.purchase = {
                            id: null,
                            price: null,
                            quantity: null,
                            subtotal: null,
                            selectedProd: "",
                            nameProd: "",
                        }
                        this.proveOptions = [],
                        this.metoOptions = [],
                        this.prodOptions = []
                    }
                })
                .catch((errors) => {
                    this.$refs.SweetAlert.showError(errors);
                });
            }
        });
    },

    closeModal: function () {
      this.modal = {
        title: "",
        modal_form: false,
        idReci: null,
        payload: [],
      };
    },

    isNumber: function (evt) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (
            charCode > 31 &&
            (charCode < 48 || charCode > 57) &&
            charCode !== 46
        ) {
            evt.preventDefault();
        } else {
            return true;
        }
    },

    validateQuantity(event) {
        let value = parseInt(event.target.value);
        if (value < 1 || isNaN(value)) {
            event.target.value = 1;
            this.purchase.quantity = 1;
        } else {
            this.purchase.quantity = value;
        }
    },

    /** paginación */
    backPage() {
      this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
    },
    nextPage() {
      this.selectPage =
        this.selectPage < this.stepPagination.length
          ? this.selectPage + 1
          : this.stepPagination.length;
    },
    selectedPage(page) {
      this.selectPage = page;
    },
  },
  filters: {
    formatDate(date) {
      return date != null ? moment(date).format("DD/MM/YYYY") : "-";
    },
    formatDateTime(dateTime) {
      return dateTime != null ? moment(dateTime).format("DD/MM/YYYY HH:mm") : "-";
    },
  },
};
</script>